<template>
  <div class="card p-4 shadow-sm rounded-3 info-patient-card">
    <!-- En-tête -->
   <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap">
  <h4 class="fw-bold mb-0 text-primary">
    <i class="bi bi-person-lines-fill me-2"></i> Informations personnelles
  </h4>

  <div class="d-flex align-items-center gap-2">

    <button
      class="btn btn-outline-primary btn-sm"
      v-if="$store.getters.hasPermission('IMPRESSION_FICHE_PATIENT')"
      @click="imprimerFicheMedicale"
    >
      <i class="bi bi-printer"></i>
    </button>

    <div class="btn-group">
      <button v-dropdown-fixed type="button" class="btn btn-outline-success btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="bi bi-share-fill"></i> Partager
      </button>
      <ul class="dropdown-menu dropdown-menu-end">
        <li><a class="dropdown-item" @click="copierFiche">
          <i class="bi bi-clipboard me-2"></i>Copier le texte
        </a></li>
        <li><a class="dropdown-item" @click="partagerWhatsapp">
          <i class="bi bi-whatsapp me-2"></i>WhatsApp
        </a></li>
        <li><a class="dropdown-item" @click="partagerEmail">
          <i class="bi bi-envelope me-2"></i>Email
        </a></li>
      </ul>
    </div>

  </div>
</div>

    <!-- Loader -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2">Chargement des informations...</p>
    </div>

    <!-- Informations -->
    <div v-else-if="patient" class="row g-4">

      <!-- Repères : âge, mineur, ce qui manque au dossier (jamais bloquant) -->
      <div class="col-12 d-flex flex-wrap align-items-center gap-2">
        <span v-if="patient.ageAffiche" class="badge bg-primary-subtle text-primary-emphasis fs-6">{{ patient.ageAffiche }}</span>
        <span v-if="patient.mineur" class="badge bg-info-subtle text-info-emphasis">Mineur</span>
        <span v-if="patient.nomProvisoire" class="badge bg-warning-subtle text-warning-emphasis">Nom provisoire</span>
        <span v-if="(patient.elementsManquants || []).length" class="badge bg-warning text-dark" :title="patient.elementsManquants.join(', ')">
          <i class="bi bi-exclamation-circle me-1"></i>Dossier à compléter
        </span>
        <small v-if="(patient.elementsManquants || []).length" class="text-muted">À compléter : {{ patient.elementsManquants.join(' · ') }}</small>
        <router-link v-if="(patient.elementsManquants || []).length && $store.getters.hasPermission('PATIENT_EDIT')" class="btn btn-sm btn-outline-warning ms-auto" :to="{ name: 'edit_patient', params: { id: patient.id } }">
          <i class="bi bi-pencil me-1"></i>Compléter
        </router-link>
      </div>

      <!-- Nom + Prénom -->
      <div class="col-md-4"><p><strong>Nom :</strong> {{ patient.nom }}</p></div>
      <div class="col-md-4"><p><strong>Prénom :</strong> {{ patient.prenom }}</p></div>

      <!-- Sexe + Naissance -->
      <div class="col-md-4"><p><strong>Sexe :</strong> {{ patient.genre || "Non renseigné" }}</p></div>
      <div class="col-md-4"><p><strong>Date de naissance :</strong> {{ formatDate(patient.dateNaissance) }}</p></div>
      <div class="col-md-4"><p><strong>Âge :</strong> {{ patient.ageAffiche || "—" }}
        <span v-if="patient.heureNaissance || patient.poidsNaissance" class="text-muted small">
          (naissance<span v-if="patient.heureNaissance"> à {{ patient.heureNaissance }}</span><span v-if="patient.poidsNaissance"> · {{ patient.poidsNaissance }} g</span>)
        </span></p></div>

      <!-- Téléphone + Email + Adresse -->
      <div class="col-md-4"><p><strong>Téléphone :</strong> {{ patient.telephone || "—" }}</p></div>
      <div class="col-md-4"><p><strong>Email :</strong> {{ patient.email || "—" }}</p></div>
      <div class="col-md-4"><p><strong>Adresse :</strong> {{ patient.adresse || "—" }}</p></div>

      <!-- NUMÉRO DOSSIER -->
      <div class="col-md-4"><p><strong>N° Dossier :</strong> {{ patient.numeroDossier || "Non attribué" }}</p></div>

      <!-- Groupe sanguin -->
      <div class="col-md-4"><p><strong>Groupe Sanguin :</strong> {{ patient.groupeSanguin || "—" }}</p></div>

      <!-- Maladies particulières -->
      <div class="col-md-4">
        <p><strong>Antécedents médicaux :</strong> {{ patient.antecedentsMedicaux || "Aucune" }}</p>
      </div>

      <!-- Allergies -->
      <div class="col-md-4">
        <p><strong>Allergies :</strong> {{ patient.allergies || "Aucune" }}</p>
      </div>

      <!-- Profession -->
      <div class="col-md-4">
        <p><strong>Profession :</strong> {{ patient.profession || "—" }}</p>
      </div>

    

      <!-- Famille et contact -->
      <div class="col-md-12 mt-3">
        <div class="d-flex justify-content-between align-items-center border-bottom pb-1 flex-wrap gap-2">
          <h5 class="text-primary fw-bold mb-0">Famille et contact</h5>
          <button v-if="patient.genre === 'Feminin' && peutCreerNouveauNe" class="btn btn-sm btn-outline-primary" @click="nouveauNe = true">
            <i class="bi bi-balloon-heart me-1"></i>Enregistrer un nouveau-né
          </button>
        </div>
      </div>
      <div class="col-md-6">
        <p class="mb-1"><strong>Responsables légaux :</strong></p>
        <ul class="list-unstyled mb-0" v-if="(patient.responsablesListe || []).length">
          <li v-for="r in patient.responsablesListe" :key="r.id" class="mb-1">
            <span class="badge bg-light text-dark border me-1">{{ r.lienLibelle }}</span>
            <router-link v-if="r.patientLie" :to="{ name: 'information_personnelle', params: { id: r.patientLie.id } }">{{ r.nomComplet }}</router-link>
            <span v-else>{{ r.nomComplet }}</span>
            <span v-if="r.telephone"> · {{ r.telephone }}</span>
            <span v-if="r.principal" class="text-muted small"> (contact principal)</span>
          </li>
        </ul>
        <span v-else class="text-muted fst-italic">{{ patient.mineur ? "Aucun responsable renseigné" : "—" }}</span>
      </div>
      <div class="col-md-6">
        <p class="mb-1"><strong>SMS envoyés à :</strong> {{ (patient.telephonesSms || []).join(", ") || "personne (aucun numéro)" }}</p>
        <p class="mb-1"><strong>Contact d’urgence :</strong>
          {{ patient.contactUrgenceNom ? patient.contactUrgenceNom + " · " : "" }}{{ patient.contactUrgenceTelephone || "—" }}</p>
      </div>
      <div class="col-md-12" v-if="famille.enfants.length">
        <p class="mb-1"><strong>Enfants suivis dans la clinique :</strong></p>
        <div class="d-flex flex-wrap gap-2">
          <router-link v-for="e in famille.enfants" :key="e.id" class="btn btn-sm btn-light border" :to="{ name: 'information_personnelle', params: { id: e.id } }">
            <i class="bi bi-person me-1"></i>{{ e.nomComplet }}<span class="text-muted" v-if="e.ageAffiche"> · {{ e.ageAffiche }}</span>
          </router-link>
        </div>
      </div>

      <!-- Informations Assurance -->
      <div class="col-md-12 mt-3">
        <h5 class="text-primary fw-bold border-bottom pb-1">Informations assurance</h5>
      </div>

      <div class="col-12">

  <div
    v-if="contratsAssurance.length"
    class="table-responsive"
  >

    <table class="table table-sm table-bordered align-middle">

      <thead class="table-light">
        <tr>
          <th>Assurance</th>
          <th>N° Assuré</th>
          <th>Couverture</th>
          <th>Date début</th>
          <th>Date fin</th>
        </tr>
      </thead>

      <tbody>

        <tr
          v-for="contrat in contratsAssurance"
          :key="contrat.id"
        >
          <td>{{ contrat.assurance.nom }}</td>

          <td>{{ contrat.numeroAssure }}</td>

          <td>
            {{ contrat.tauxCouverture }} %
          </td>

          <td>{{ formatDate(contrat.dateDebut) }}</td>

          <td>{{ formatDate(contrat.dateFin) }}</td>

        </tr>

      </tbody>

    </table>

  </div>

  <div
    v-else
    class="text-muted fst-italic"
  >
    Aucune assurance enregistrée.
  </div>

</div>
    </div>

    <div v-else class="text-center text-muted py-4">
      <i class="bi bi-info-circle fs-3 d-block mb-2"></i>
      <p>Aucune information trouvée pour ce patient.</p>
    </div>

    <ApplicationMobilePatient v-if="patient && voitApplicationMobile" class="mt-3" :patient-id="patient.id" />

    <NouveauNeModal v-if="nouveauNe && patient" :mere="patient" @fermer="nouveauNe = false" @cree="apresNouveauNe" />
  </div>
</template>


<script>
import api from "@/api";
import { imprimer, e, blocInfos, nomComplet, dateFr } from "@/impression/impression";
import NouveauNeModal from "@/components/patient/NouveauNeModal.vue";
import ApplicationMobilePatient from "@/components/patient/ApplicationMobilePatient.vue";

export default {
  components: { NouveauNeModal, ApplicationMobilePatient },
  props: ["patientId"],
  data() {
    return {
      patient: null,
      famille: { enfants: [] },
      nouveauNe: false,
      isLoading: true,
      configClinique: {},
      contratsAssurance: []
    };
  },

  created() {
    this.fetchPatient();
    this.fetchFamille();
    this.fetchConfigClinique();
    this.fetchContratsAssurance();
    console.log(this.CurrentUser);
  },

  computed: {
    CurrentUser() {
      return this.$store.getters.user;
    },
    voitApplicationMobile() {
      return this.$store.getters.hasModule('APPLI_PATIENT')
        && this.$store.getters.hasAnyPermission(['PATIENT_DOSSIER', 'PATIENT_EDIT', 'PATIENT_CREATE']);
    },
    peutCreerNouveauNe() {
      return this.$store.getters.hasAnyPermission(["PATIENT_CREATE", "HOSP_CREATE", "HOSPITALISATION_CREATE"]);
    },
  },
  watch: {
    patientId() {
      this.fetchPatient();
      this.fetchFamille();
    },
  },

  methods: {
    async fetchFamille() {
      try {
        const res = await api.getItem("patients", `${this.patientId}/famille`);
        this.famille = res.data || { enfants: [] };
      } catch (error) {
        this.famille = { enfants: [] };
      }
    },
    apresNouveauNe(resultat) {
      this.nouveauNe = false;
      this.famille = resultat.famille || this.famille;
      const premier = (resultat.data || [])[0];
      if (premier) {
        this.$router.push({ name: "information_personnelle", params: { id: premier.id } });
      }
    },
    texteResponsables(p) {
      return (p.responsablesListe || []).map(r => `${r.lienLibelle} : ${r.nomComplet}${r.telephone ? " (" + r.telephone + ")" : ""}`).join(" ; ");
    },
    async fetchContratsAssurance() {
    if (!this.$store.getters.hasModule('ASSURANCES')) { this.contratsAssurance = []; return; }
  try {
    const res = await api.getItems(
      `patients/${this.patientId}/contrats-assurance`
    );

    this.contratsAssurance = res.data || [];

  } catch (error) {
    console.error("Erreur contrats assurance :", error);
  }
},
 buildTexteFiche() {
  const p = this.patient;
  const config = this.configClinique || {};

  return `🏥 ${config.nom || "Clinique"}
${config.adresse ? config.adresse + "\n" : ""}${config.telephone ? "Tél : " + config.telephone + "\n" : ""}
——————————————
Fiche patient
Nom : ${p.nom} ${p.prenom}
Sexe : ${p.genre || "—"}
Âge : ${p.ageAffiche || "—"}
N° Dossier : ${p.numeroDossier || "Non attribué"}
Groupe sanguin : ${p.groupeSanguin || "—"}
Allergies : ${p.allergies || "Aucune"}
Antécédents médicaux : ${p.antecedentsMedicaux || "Aucun"}
Contact urgence : ${p.contactUrgenceNom ? p.contactUrgenceNom + " " : ""}${p.contactUrgenceTelephone || "—"}${(p.responsablesListe || []).length ? "\nResponsables : " + this.texteResponsables(p) : ""}`;
},

  async copierFiche() {
    if (!this.patient) return;
    try {
      await navigator.clipboard.writeText(this.buildTexteFiche());
      alert("Informations copiées dans le presse-papiers.");
    } catch (e) {
      alert("Impossible de copier automatiquement.");
    }
  },

  partagerWhatsapp() {
  if (!this.patient) return;

  const texte = this.buildTexteFiche();

  if (this.patient.telephone) {
    let num = this.patient.telephone.replace(/[\s()-]/g, "");

    if (num.startsWith("+")) {
      num = num.substring(1);
    } else if (num.startsWith("00")) {
      num = num.substring(2);
    } else {
      const defaultCode = process.env.VUE_APP_DEFAULT_COUNTRY_CODE;
      if (defaultCode && !num.startsWith(defaultCode)) {
        num = defaultCode + num;
      }
    }

    window.open(`https://wa.me/${num}?text=${encodeURIComponent(texte)}`, "_blank");
  } else {
    // Pas de numéro enregistré : on laisse choisir un contact
    window.open(`https://wa.me/?text=${encodeURIComponent(texte)}`, "_blank");
  }
},

  partagerEmail() {
    if (!this.patient) return;
    const p = this.patient;
    const sujet = `Fiche patient - ${p.nom} ${p.prenom}`;
    const url = `mailto:?subject=${encodeURIComponent(sujet)}&body=${encodeURIComponent(this.buildTexteFiche())}`;
    window.location.href = url;
  },
    async fetchPatient() {
      this.isLoading = true;
      try {
        const res = await api.getItem("patients", this.patientId);
        this.patient = res.data;
      } catch (error) {
        console.error("Erreur patient :", error);
      } finally {
        this.isLoading = false;
      }
    },

    async fetchConfigClinique() {
      try {
        const res = await api.getItems("configurations");
        this.configClinique = res.data.data?.[0] || {};
      } catch (err) {
        console.error("Erreur config clinique", err);
      }
    },

    formatDate(date) {
      if (!date) return "—";
      return new Date(date).toLocaleDateString("fr-FR", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    calculAge(date) {
      if (!date) return "—";
      const now = new Date();
      const birth = new Date(date);

      let age = now.getFullYear() - birth.getFullYear();
      const m = now.getMonth() - birth.getMonth();

      if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) {
        age--;
      }

      return age;
    },

async imprimerFicheMedicale() {
  if (!this.patient) return;

  const patient = this.patient;
  const config = this.configClinique || {};
  const user = this.CurrentUser || {};
  const ageTxt = patient.ageAffiche;

  const assurancesHtml = this.contratsAssurance.length > 0
    ? `<table class="lignes">
        <thead><tr><th>Assurance</th><th>N° assuré</th><th class="centre">Couverture</th><th>Date début</th><th>Date fin</th></tr></thead>
        <tbody>
          ${this.contratsAssurance.map(c => `
            <tr>
              <td>${e(c.assurance?.nom || "—")}</td>
              <td>${e(c.numeroAssure || "—")}</td>
              <td class="centre">${e(c.tauxCouverture ?? 0)} %</td>
              <td>${e(dateFr(c.dateDebut) || "—")}</td>
              <td>${e(dateFr(c.dateFin) || "—")}</td>
            </tr>`).join("")}
        </tbody>
      </table>`
    : '<p class="muted">Aucune assurance enregistrée.</p>';

  const corps = `
    <div class="section">Informations personnelles</div>
    ${blocInfos([
      ["Nom", patient.nom || "—"],
      ["Prénom", patient.prenom || "—"],
      ["Sexe", patient.genre || "—"],
      ["Âge", ageTxt || "—"],
      ["Date de naissance", dateFr(patient.dateNaissance) || "—"],
      ["N° dossier", patient.numeroDossier || "—"],
      ["Adresse", patient.adresse || "—"],
      ["Téléphone", patient.telephone || "—"],
      ["Email", patient.email || "—"],
      ["Profession", patient.profession || "—"],
      ["Contact d’urgence", (patient.contactUrgenceNom ? patient.contactUrgenceNom + " · " : "") + (patient.contactUrgenceTelephone || "—")],
      ...((patient.responsablesListe || []).length ? [["Responsables légaux", this.texteResponsables(patient)]] : []),
      ["Groupe sanguin", patient.groupeSanguin || "—"],
      ["Allergies", patient.allergies || "—"],
    ])}
    <div class="section">Antécédents médicaux</div>
    <div class="texte">${e(patient.antecedentsMedicaux || "—")}</div>
    <div class="section">Informations assurance</div>
    ${assurancesHtml}`;

  const auteur = nomComplet(user);
  const lieu = config.ville ? `Fait à ${e(config.ville)}, le ` : "Fait le ";

  await imprimer({
    titre: "Fiche du patient",
    numero: `PAT-${patient.id}-${new Date().getFullYear()}`,
    date: dateFr(new Date()),
    corps,
    signature: {
      droite: `${lieu}${e(dateFr(new Date()))}`
        + (user.typeUser?.nom ? `<br><strong>${e(user.typeUser.nom)}</strong>` : "")
        + (auteur ? `<br>${e(auteur)}` : "")
        + '<br><span class="muted">Signature et cachet</span>',
    },
  });
},
partagerFiche() {
  if (!this.patient) return;

  const p = this.patient;
  const config = this.configClinique || {};

  const texte =
`Fiche patient - ${config.nom || "Clinique"}
Nom : ${p.nom} ${p.prenom}
Sexe : ${p.genre || "—"}
Âge : ${p.ageAffiche || "—"}
N° Dossier : ${p.numeroDossier || "Non attribué"}
Groupe sanguin : ${p.groupeSanguin || "—"}
Allergies : ${p.allergies || "Aucune"}
Antécédents médicaux : ${p.antecedentsMedicaux || "Aucun"}
Contact urgence : ${p.contactUrgenceNom ? p.contactUrgenceNom + " " : ""}${p.contactUrgenceTelephone || "—"}${(p.responsablesListe || []).length ? "\nResponsables : " + this.texteResponsables(p) : ""}`;

  if (navigator.share) {
    navigator.share({
      title: `Fiche patient - ${p.nom} ${p.prenom}`,
      text: texte
    }).catch(() => {});
  } else {
    const url = `https://wa.me/?text=${encodeURIComponent(texte)}`;
    window.open(url, "_blank");
  }
}



  },
};
</script>

<style scoped>
.info-patient-card {
  background: #fff;
  border-radius: 12px;
}

p {
  margin-bottom: 0;
  font-size: 0.95rem;
}

h5 {
  margin-top: 15px;
}

@media print {
  button {
    display: none !important;
  }
}
</style>

